import { Dialog, DialogProps } from '@mui/material';
import { LoadingSpinner } from './LoadingSpinner';

interface IProps extends Omit<DialogProps, 'open'> {
  unmount?: () => void;
}

export const LoadingDialog = ({
  unmount,
  maxWidth,
  fullWidth,
  scroll,
  ...rest
}: IProps) => (
  <Dialog open={true} scroll={scroll ?? 'paper'} onClose={unmount} {...rest}>
    <LoadingSpinner />
  </Dialog>
);
